import {atom} from "recoil";
const titleDefault = process.env.REACT_APP_TITLE || 'GGPAY';

export const titleState = atom({
    key: 'titleState', // unique ID (with respect to other atoms/selectors)
    default: titleDefault,
});
